import React from 'react';
import { useTheme } from '../../ThemeContext';
import { Link, useNavigate } from 'react-router-dom';
const videos = [
    { id: 'ios', title: 'Как установить на iOS', src: 'https://vk.com/video_ext.php?oid=5425381&id=456239401&hd=2' },
    { id: 'android', title: 'Как установить на Android', src: 'https://vk.com/video_ext.php?oid=5425381&id=456239402&hd=2' },
    { id: 'auth', title: 'Как авторизоваться', src: 'https://vk.com/video_ext.php?oid=5425381&id=456239403&hd=2' },
    { id: 'feed', title: 'Элементы ленты скидок', src: 'https://vk.com/video_ext.php?oid=5425381&id=456239404&hd=2' },
    { id: 'filters', title: 'Объяснение фильтров', src: 'https://vk.com/video_ext.php?oid=5425381&id=456239405&hd=2' },
    { id: 'watchlist', title: 'Объяснение листа отслеживания', src: 'https://vk.com/video_ext.php?oid=5425381&id=456239406&hd=2' },
];

const VideosPage = () => {
    const { theme } = useTheme();
    const isDark = theme === 'dark';

    return (
        <div className={`sb-videos ${isDark ? 'sb-dark' : 'sb-light'} scrollable`}>
            <style>{`
        :root{
          --sb-maxw: 87.5rem;
          --sb-bg-light:#f5f7fb; --sb-bg-dark:#0b0f19;
          --sb-heading-light:#0f172a; --sb-heading-dark:#fff;
          --sb-text-light:#1f2937; --sb-text-dark:#e5e7eb;
          --sb-muted-light:#475569; --sb-muted-dark:#9aa4b2;
          --sb-accent:#7c3aed; --sb-accent-2:#22d3ee;
          --sb-border:rgba(255,255,255,0.12);
          --sb-card-light:rgba(255,255,255,0.7);
          --sb-card-dark:rgba(15,23,42,0.4);
        }
        .sb-videos{min-height:100vh; overflow-y:auto; background:var(--sb-bg-light); color:var(--sb-text-light);}
        .sb-dark.sb-videos{background:var(--sb-bg-dark); color:var(--sb-text-dark);}

        .sb-v-head{max-width:var(--sb-maxw); margin:0 auto; padding:18px 22px 8px;}
        .sb-v-badge{display:inline-block; padding:6px 10px; border-radius:999px; font-weight:700; font-size:12px; color:#fff;
          background:linear-gradient(135deg,var(--sb-accent),var(--sb-accent-2)); margin-right:10px;}
        .sb-v-title{display:inline-block; font-weight:900; font-size:clamp(22px,2.6vw,32px); color:var(--sb-heading-light); margin:0;}
        .sb-dark .sb-v-title{color:var(--sb-heading-dark);}

        /* сетка карточек: компактно */
        .sb-v-grid{
          max-width:var(--sb-maxw); margin:10px auto 26px; padding:0 22px;
          display:grid; gap:16px;
          grid-template-columns: repeat(3, minmax(180px, 1fr));
        }
        @media (max-width: 1280px){ .sb-v-grid{ grid-template-columns: repeat(3, minmax(180px, 1fr)); } }
        @media (max-width: 980px){  .sb-v-grid{ grid-template-columns: repeat(2, minmax(180px, 1fr)); } }
        @media (max-width: 720px){  .sb-v-grid{ grid-template-columns: 1fr; padding:0 16px; } }

        .sb-card{border:1px solid var(--sb-border); border-radius:16px; background:var(--sb-card-light); padding:12px;}
        .sb-dark .sb-card{background:var(--sb-card-dark);}
        .sb-embed{position:relative; width:100%; aspect-ratio:9/16; border-radius:12px; overflow:hidden; background:#000;}
        .sb-iframe{position:absolute; inset:0; width:100%; height:100%; border:0;}
        .sb-title{margin:8px 4px 2px; font-size:14px; font-weight:800; color:var(--sb-heading-light);}
        .sb-dark .sb-title{color:var(--sb-heading-dark);}
        .sb-note{margin:0 4px 6px; font-size:12px; color:var(--sb-muted-light);}
        .sb-dark .sb-note{color:var(--sb-muted-dark);}
        .sb-header{position:sticky;top:0;z-index:10;display:flex;align-items:center;justify-content:space-between;padding:14px 22px;border-bottom:1px solid var(--sb-border)}
        .sb-light .sb-header{background:rgba(255,255,255,.9);backdrop-filter:blur(8px)}
        .sb-dark .sb-header{background:rgba(0,0,0,.35);backdrop-filter:blur(8px)}
        .sb-logo{display:flex;align-items:center;gap:10px;text-decoration:none;color:inherit;font-weight:800;letter-spacing:.2px;font-size:18px}
        .sb-logo-img{width:36px;height:36px;border-radius:8px;background:linear-gradient(135deg,var(--sb-accent),var(--sb-accent-2));flex:0 0 36px}
        @media (max-width:768px){
          .sb-header{padding:12px 16px}
          .sb-logo span{font-size:16px}
          }
          

      `}</style>
            <header className="sb-header">
                <Link className="sb-logo" to="/">
                    <img className="sb-logo-img" src="android-icon-36x36.png" alt="Salew Bot" width={36} height={36} />
                    <span>Salew Bot</span>
                </Link>

            </header>
            <div className="sb-v-head">
                <span className="sb-v-badge">Видеопомощь</span>
                <h1 className="sb-v-title">Как пользоваться Salew Bot</h1>
            </div>

            <div className="sb-v-grid">
                {videos.map(v => (
                    <article className="sb-card" key={v.id}>
                        <div className="sb-embed">
                            <iframe
                                className="sb-iframe"
                                src={`${v.src}&autoplay=0`}    /* сразу VK-плеер; превью подтянется из VK */
                                title={v.title}
                                loading="lazy"
                                allow="autoplay; encrypted-media; fullscreen; picture-in-picture; screen-wake-lock;"
                                allowFullScreen
                            />
                        </div>
                        <h3 className="sb-title">{v.title}</h3>
                    </article>
                ))}
            </div>
        </div>
    );
};

export default VideosPage;
